// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#Search[data-v-4fd5697e] {\n  position: absolute;\n  right: 40px;\n}\n.el-input[data-v-4fd5697e] {\n  width: 150px;\n}\n.hot-search[data-v-4fd5697e],\n.search-list[data-v-4fd5697e] {\n  position: absolute;\n  top: 35px;\n  right: -40px;\n  width: 350px;\n  z-index: 1000;\n  background-color: white;\n  box-shadow: 0 0.14286rem 0.57143rem 0 rgb(0 0 0 / 20%);\n}\n", ""]);
// Exports
module.exports = exports;
